import { NotificationView } from "./notifications-view";
import { useNotifications } from "./use-notifications";

const Notifications = () => {
  const logic = useNotifications();
  return <NotificationView {...logic} />;
};

export default Notifications;
